import { createActions } from 'redux-actions';

export const {
  openBottomBar,
  toggleBottomBarDetail,
  hideBottomBar,
} = createActions(
  'OPEN_BOTTOM_BAR',
  'TOGGLE_BOTTOM_BAR_DETAIL',
  'HIDE_BOTTOM_BAR',
);



// WEBPACK FOOTER //
// ./src/store/actions/BottomBar/index.js